module.exports = __webpack_public_path__ + "6c1904151daf6047985f420b55a971bb.pdf";